<!--资源中心菜单-->
<template>
    <div class="menu-container">
        <div @click="changeMenu('1','1')"
             :class="activeChildItem==='1'?'menu-item menu-active':'menu-item'">
            教师发展中心
        </div>
        <div v-if="activeChildItem==='1'&&isShow" class="child-menu-container">
            <div @click="changeItem('1','1','0')" class="chile-item-container">
                <div :class="activeItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">
                    高水平示范课
                </div>
            </div>
            <div @click="changeItem('2','1','0')" class="chile-item-container">
                <div :class="activeItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">
                    区本课程
                </div>
            </div>
            <div @click="changeItem('3','1','0')" class="chile-item-container">
                <div :class="activeItem==='3'?'child-menu-item child-menu-active':'child-menu-item'">
                    校本课程
                </div>
            </div>
            <div @click="changeItem('5','1','0')" class="chile-item-container">
                <div :class="activeItem==='5'?'child-menu-item child-menu-active':'child-menu-item'">
                    人工智能
                </div>
            </div>
<!--            <div @click="changeItem('26','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='26'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    科学素养-->
<!--                </div>-->
<!--            </div>-->
            <div @click="changeItem('6','1','0')" class="chile-item-container">
                <div :class="activeItem==='6'?'child-menu-item child-menu-active':'child-menu-item'">
                    互动课件
                </div>
            </div>
            <div @click="changeItem('7','1','0')" class="chile-item-container">
                <div :class="activeItem==='7'?'child-menu-item child-menu-active':'child-menu-item'">
                    恒岳助教
                </div>
            </div>

            <div @click="changeItem('20','1','0')" class="chile-item-container">
                <div :class="activeItem==='20'?'child-menu-item child-menu-active':'child-menu-item'">
                    幼儿园资源
                </div>
            </div>

            <div @click="changeItem('21','1','0')" class="chile-item-container">
                <div :class="activeItem==='21'?'child-menu-item child-menu-active':'child-menu-item'">
                    小学资源
                </div>
            </div>

            <div @click="changeItem('22','1','0')" class="chile-item-container">
                <div :class="activeItem==='22'?'child-menu-item child-menu-active':'child-menu-item'">
                    初中资源
                </div>
            </div>

<!--            <div @click="changeItem('23','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='23'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    高中资源-->
<!--                </div>-->
<!--            </div>-->

<!--            <div @click="changeItem('24','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='24'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    初中题库<span style="font-size: 12px;">（日清周结）</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div @click="changeItem('25','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='25'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    高中题库<span style="font-size: 12px;">（三层量分定做）</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div @click="changeItem('27','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='27'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    小学资源<span style="font-size: 12px;">（组卷）</span>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div @click="changeItem('28','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='28'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    初中资源<span style="font-size: 12px;">（组卷）</span>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div @click="changeItem('29','1','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='29'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    高中资源<span style="font-size: 12px;">（组卷）</span>-->
<!--                </div>-->
<!--            </div>-->



            <div @click="changeItem('9','1','0')" class="chile-item-container">
                <div :class="activeItem==='9'?'child-menu-item child-menu-active':'child-menu-item'">
                    国家智慧教育云平台
                </div>
            </div>
        </div>


        <div @click="changeMenu('10','2')"
             :class="activeChildItem==='2'?'menu-item menu-active':'menu-item'">
            学校文化中心
        </div>
        <div v-if="activeChildItem==='2'&&isShow" class="child-menu-container">
            <div @click="changeItem('10','2','0')" class="chile-item-container">
                <div :class="activeItem==='10'?'child-menu-item child-menu-active':'child-menu-item'">
                    党建引领
                </div>
            </div>
            <div @click="changeItem('11','2','0')" class="chile-item-container">
                <div :class="activeItem==='11'?'child-menu-item child-menu-active':'child-menu-item'">
                    政策法规
                </div>
            </div>
<!--            <div @click="changeItem('14','2','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='14'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    美育浸润-->
<!--                </div>-->
<!--            </div>-->
<!--            <div @click="changeItem('15','2','0')" class="chile-item-container">-->
<!--                <div :class="activeItem==='15'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    恒岳阅读-->
<!--                </div>-->
<!--            </div>-->
            <div v-if="role==1||role==2||isRwmy==1" class="auto-chile-item-container">
                <div @click="changeItem('30','2','rwmyMuseum')" :class="activeItem==='30'||activeItem==='31'||activeItem==='32'||activeItem==='33'||activeItem==='34'||activeItem==='35'?'child-menu-item child-menu-active':'child-menu-item'">
                    美育浸润•五馆合一
                </div>
                <!--  三级菜单 -->
                <div @click="changeItemChild('31','2','rwmyMuseum','hyyd')" v-if="activeLaseChild==='rwmyMuseum'"
                     :class="levelItem==='hyyd'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">
                    恒岳•阅读拓展馆
                </div>
                <div @click="changeItemChild('32','2','rwmyMuseum','kjys')" v-if="activeLaseChild==='rwmyMuseum'"
                     :class="levelItem==='kjys'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">
                    恒岳•科技艺术馆
                </div>
                <div @click="changeItemChild('33','2','rwmyMuseum','fywh')" v-if="activeLaseChild==='rwmyMuseum'"
                     :class="levelItem==='fywh'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">
                    恒岳•非遗文化馆
                </div>
                <div @click="changeItemChild('34','2','rwmyMuseum','ldsj')" v-if="activeLaseChild==='rwmyMuseum'"
                     :class="levelItem==='ldsj'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">
                    恒岳•劳动实践营
                </div>
                <div @click="changeItemChild('35','2','rwmyMuseum','zryx')" v-if="activeLaseChild==='rwmyMuseum'"
                     :class="levelItem==='zryx'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">
                    恒岳•研学体验馆
                </div>
            </div>
        </div>

        <div @click="changeMenu('4','3')"
             :class="activeChildItem==='3'?'menu-item menu-active':'menu-item'">
            学生成长中心
        </div>
        <div v-if="activeChildItem==='3'&&isShow" class="child-menu-container">
            <div @click="changeItem('4','3','0')" class="chile-item-container">
                <div :class="activeItem==='4'?'child-menu-item child-menu-active':'child-menu-item'">
                    课后服务
                </div>
            </div>
<!--            <div v-if="role==1||role==2||isRwmy==1" class="chile-item-container">-->
<!--                <div @click="changeItem('12','3','rwmy')" :class="activeItem==='12'||activeItem==='13'?'child-menu-item child-menu-active':'child-menu-item'">-->
<!--                    美育浸润·五馆和一-->
<!--                </div>-->
<!--                &lt;!&ndash;  三级菜单 &ndash;&gt;-->
<!--                <div @click="changeItemChild('12','3','rwmy','wg')" v-if="activeLaseChild==='rwmy'"-->
<!--                     :class="levelItem==='wg'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">-->
<!--                    五馆合一-->
<!--                </div>-->
<!--                <div @click="changeItemChild('13','3','rwmy','kxk')" v-if="activeLaseChild==='rwmy'"-->
<!--                     :class="levelItem==='kxk'?'last-child-menu-item last-child-menu-active':'last-child-menu-item'">-->
<!--                    博雅大语文-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>

export default {
    name:'courseMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"1",
            activeChildItem:"1",
            activeLaseChild:"1",
            levelItem:'wg',
            role:this.$storage.get("role"),
            isShow:true,
            isRwmy:JSON.parse(this.$storage.get("userInfo")).isRwmy,
        }
    },
    methods: {
        changeMenu(item,childItem){
            if (childItem === this.activeChildItem){
                this.activeChildItem = childItem;
                this.isShow = !this.isShow;
            }else {
                this.activeChildItem = childItem;
                this.activeItem = item;
                this.isShow = true;
                this.$emit('change-item', item );
            }
        },
        changeItem(item,childItem,lastChild){
            this.activeItem = item;
            this.activeChildItem = childItem;
            this.activeLaseChild = lastChild;
            this.levelItem = "";
            this.$emit('change-item', item );
        },

        changeItemChild(item,childItem,lastChild,levelItem){
            this.activeItem = item;
            this.activeChildItem = childItem;
            this.activeLaseChild = lastChild;
            this.levelItem = levelItem;
            this.$emit('change-item', item );
        },

    }
}

</script>

<style scoped>
.menu-container{
    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
    overflow-y: auto;
}
.menu-container::-webkit-scrollbar{width:0!important}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 10px;
    font-size: 16px;
    //color: #707070;
    color: #000;
    cursor: pointer;
    font-weight: bold;
    //font-family: sans-serif;
}
.menu-active{
    background: #0d55a4;
    //color: #ffbf6b;
    color: #000;
    font-weight: bold;
}

.child-menu-container{
    width: 100%;
    height: auto;
}
.chile-item-container{
    width: 100%;
    height: 40px;
    padding: 2px 0 2px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.auto-chile-item-container{
    width: 100%;
    height: auto;
    padding: 2px 0 2px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.child-menu-item{
    width: auto;
    height: 36px;
    line-height: 36px;
    text-align: left;
    font-size: 14px;
    text-indent: 20px;
}

.child-menu-active{
    background: #0d55a4;
    color: #fff;
}

.last-child-menu-item{
    width: auto;
    height: 26px;
    line-height: 26px;
    text-align: left;
    font-size: 14px;
    text-indent: 40px;
    margin: 2px 0 2px 0;
}

.last-child-menu-active{
    background: #0d55a4;
    color: #fff;
}


</style>